"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useImageControl = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _utils = require("../../utils");

var _interfaces = require("../interfaces");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// This hook controls ToolbarImageModal and handles key navigation inside it
var useImageControl = function useImageControl(editorInstance, setModalToMount, selectedImageNode) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isImageModalOpen = _useState2[0],
      setIsImageModalOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      imageModalProps = _useState4[0],
      setImageModalProps = _useState4[1];

  var setImage = (0, _react.useCallback)(function (params) {
    if (editorInstance) {
      editorInstance.commands.image.set(params);
      setIsImageModalOpen(false);
    }
  }, [editorInstance]);
  var openImageModal = (0, _react.useCallback)(function (node) {
    if (node) {
      var _node$attrs;

      var height, width;

      if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.id) {
        var element = document.getElementById(node.attrs.id);
        height = element === null || element === void 0 ? void 0 : element.offsetHeight;
        width = element === null || element === void 0 ? void 0 : element.offsetWidth;
      }

      setImageModalProps(_objectSpread(_objectSpread({}, node.attrs), {}, {
        height: height,
        width: width
      }));
    } else {
      setImageModalProps({});
    }

    setModalToMount(_interfaces.RTEModals.Image);
    setIsImageModalOpen(true);
  }, [setModalToMount]);
  var closeImageModal = (0, _react.useCallback)(function () {
    setIsImageModalOpen(false);
  }, []);
  var canOpenImageModal = (0, _react.useRef)(false);
  var isEditorFocused = editorInstance && editorInstance.isFocused();
  canOpenImageModal.current = !!isEditorFocused && !isImageModalOpen;
  (0, _react.useEffect)(function () {
    var handler = function handler(event) {
      // Cmd+J/Ctrl+J to open image modal
      var matchLinkShortcuts = event.keyCode === _utils.EventKeyCodes.J && (event.metaKey || event.ctrlKey);

      if (canOpenImageModal.current && matchLinkShortcuts) {
        event.preventDefault();

        if (!!selectedImageNode) {
          openImageModal(selectedImageNode);
        } else {
          openImageModal();
        }
      }
    };

    document.addEventListener('keydown', handler);
    return function () {
      return document.removeEventListener('keydown', handler);
    };
  }, [openImageModal, selectedImageNode]);
  return {
    isImageModalOpen: isImageModalOpen,
    openImageModal: openImageModal,
    closeImageModal: closeImageModal,
    setImage: setImage,
    imageModalProps: imageModalProps
  };
};

exports.useImageControl = useImageControl;